exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button___button___3O7he {\n    background: transparent;\n    position: relative;\n    border: none;\n    outline: none;\n    border-radius: 0;\n    cursor: pointer;\n    -webkit-appearance: none;\n}\n\n.button___button___3O7he::after {\n    content: '';\n    width: 3rem;\n    height: 3rem;\n    position: absolute;\n    left: calc(50% - 1.5rem);\n    top: calc(50% - 1.5rem);\n    cursor: pointer;\n}", ""]);

// exports
exports.locals = {
	"button": "button___button___3O7he"
};